/*
  Hanakini – variant-aware sale badge (Oct 2026, card refresh step 6)
  Shows the sale badge and strikethrough ONLY when the colour the card is
  currently showing is discounted (variant price < compare-at price).
  Works after B4B Variant Products swaps a card to a colour (data-variant-id),
  on search results (?variant= in the link) and on "Pairs well with".

  Step 6 look:
  - Badge on the photo: wine pill (#6E2B3A) with light pink text (#F8E8EE),
    the inverse of the Limited Edition pill ("60% OFF"), top left.
  - All card text semi-bold (name, colorway, price, original price); the grey
    of the colorway and original price does the separating.
  - Original price small, grey, struck through, after the sale price.
  - No separate "SALE 60% OFF" line (the % is on the badge).
  - Prices without the currency code and without ".00" ($75, $37.50).
  - On collection pages with the colorway line: colorway left, price right,
    both the same size.
  The backup of the previous version is assets/backup-step5-hk-sale-badge.js.
*/
(function () {
  if (window.__hkSaleBadge) return;
  window.__hkSaleBadge = true;

  var css = document.createElement('style');
  css.textContent =
    '.grid-product .grid-product__tag.grid-product__tag--sale{top:8px;left:8px;right:auto;bottom:auto;' +
    'background:#6E2B3A;color:#F8E8EE;border-radius:999px;font-size:11px;font-weight:700;' +
    'letter-spacing:.08em;text-transform:uppercase;line-height:1.2;padding:5px 10px}' +
    '.grid-product__price--savings{display:none!important}' +
    '.grid-product__meta .grid-product__title,.grid-product__meta .hk-card-color{font-weight:600}' +
    '.grid-product__price,.grid-product__price .hk-now{font-weight:600}' +
    '.grid-product__price .grid-product__price--original{color:#7a6e6e;font-size:.9em;font-weight:600;text-decoration:line-through;margin:0 0 0 6px}' +
    '.grid-product__meta:has(> .hk-card-color){display:grid;grid-template-columns:minmax(0,1fr) auto;column-gap:8px;align-items:baseline}' +
    '.grid-product__meta:has(> .hk-card-color) > *{grid-column:1 / -1}' +
    '.grid-product__meta:has(> .hk-card-color) > .hk-card-color{grid-column:1}' +
    '.grid-product__meta:has(> .hk-card-color) > .hk-card-color + .grid-product__price{grid-column:2;text-align:right;white-space:nowrap;font-size:inherit}';
  (document.head || document.documentElement).appendChild(css);

  // "$75.00 USD" -> "$75", "$37.50 USD" -> "$37.50"
  function tidy(s) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return String(s)
      .replace(new RegExp('\\s*' + code + '\\b', 'g'), '')
      .replace(/<sup>00<\/sup>/g, '')
      .replace(/([.,])00(?!\d)/g, '')
      .trim();
  }

  function money(cents) {
    var s = null;
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) {
        s = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    if (!s) s = '$' + (cents / 100).toFixed(2);
    return tidy(s);
  }

  // Cards with no colour hint keep the server price, just tidied
  function tidyPriceText(card) {
    var priceEl = card.querySelector('.grid-product__price');
    if (!priceEl) return;
    var walker = document.createTreeWalker(priceEl, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (!/\d/.test(node.nodeValue)) continue;
      var lead = node.nodeValue.match(/^\s*/)[0];
      var next = lead + tidy(node.nodeValue);
      if (next.trim() !== node.nodeValue.trim()) node.nodeValue = next;
    }
  }

  function variantIdFor(card) {
    if (card.dataset.variantId) return card.dataset.variantId;
    var link = card.querySelector('a.grid-product__link');
    var m = link && (link.getAttribute('href') || '').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function variantsFor(card) {
    if (card.__hkVariants) return card.__hkVariants;
    var s = card.querySelector('script[data-selected-variant]');
    try { card.__hkVariants = s ? JSON.parse(s.textContent) : null; } catch (e) { card.__hkVariants = null; }
    return card.__hkVariants;
  }

  function apply(card) {
    var variants = variantsFor(card);
    var vid = variantIdFor(card);
    var v = null;
    if (variants && vid) {
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(vid)) { v = variants[i]; break; }
    }
    if (!v) { tidyPriceText(card); return; } // no colour hint: keep the server-rendered card

    var ci = parseInt(card.getAttribute('data-color-index'), 10);
    var color = ci >= 0 && ci < 3 ? v.options[ci] : null;
    var group = color == null ? [v] : variants.filter(function (x) { return x.options[ci] === color; });

    var onSale = !!(v.compare_at_price && v.compare_at_price > v.price);
    var colorAvailable = group.some(function (x) { return x.available; });
    var minPrice = Math.min.apply(null, group.map(function (x) { return x.price; }));
    var varies = group.some(function (x) { return x.price !== v.price; });
    var pct = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    var label = pct > 0 ? pct + '% off' : (card.dataset.hkSaleLabel || 'Sale');

    var sig = [vid, onSale, colorAvailable, minPrice].join('|');
    var priceEl = card.querySelector('.grid-product__price');
    var existing = card.querySelector('.grid-product__tag--sale');
    var badgeOk = !!card.querySelector('.grid-product__tag--custom') ||
      (onSale && colorAvailable ? !!existing && existing.textContent === label : !existing);
    if (card.dataset.hkSig === sig && badgeOk && (!priceEl || priceEl.innerHTML === card.__hkHtml)) return;
    card.dataset.hkSig = sig;

    // Price block: sale price first, then the original price struck through
    if (priceEl) {
      var d = card.dataset;
      var shown = varies
        ? (d.hkFrom || 'from [[price]]').replace('[[price]]', money(minPrice))
        : money(v.price);
      var html = '';
      if (onSale) html += '<span class="visually-hidden">' + (d.hkSalePrice || '') + '</span>';
      html += '<span class="hk-now">' + shown + '</span>';
      if (onSale) {
        html += '<span class="visually-hidden">' + (d.hkRegular || '') + '</span>' +
          '<span class="grid-product__price--original">' + money(v.compare_at_price) + '</span>';
      }
      var unit = priceEl.querySelector('.product__unit-price');
      priceEl.innerHTML = html;
      if (unit) priceEl.appendChild(unit);
      card.__hkHtml = priceEl.innerHTML;
    }

    // Sale badge (custom labels and sold-out badges are left alone)
    var content = card.querySelector('.grid-product__content');
    if (!content || content.querySelector('.grid-product__tag--custom')) return;
    var badge = content.querySelector('.grid-product__tag--sale');
    if (onSale && colorAvailable) {
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'grid-product__tag grid-product__tag--sale';
        content.insertBefore(badge, content.firstChild);
      }
      if (badge.textContent !== label) badge.textContent = label;
    } else if (badge) {
      badge.remove();
    }
  }

  var queued = false;
  function run() {
    if (!queued) return;
    queued = false;
    document.querySelectorAll('.grid-product').forEach(apply);
  }
  // Next frame, with a timer as backup (frames pause in background tabs)
  function queue() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(run);
    setTimeout(run, 120);
  }

  new MutationObserver(queue).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true,
    attributeFilter: ['data-variant-id', 'href']
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();
  window.addEventListener('load', queue);
})();
